export type BulkSigningContainer = 'pdf' | 'cades';
export const BULK_SIGNING_CONTAINER: BulkSigningContainer = 'pdf';
/**
 * Files per batch. Self-imposed, NOT a documented eID Easy vendor limit — it bounds the
 * per-batch stamping work and keeps the prepare activity inside its timeout. Exceeding it is
 * not an error: the server signs this many and reports the rest as `deferredInstanceIds` for
 * a later round (see `resolveSignaturesForActor` / `selectSlotsForBatch`). Also bounds bulk
 * post-dating via `selectDateBatch`.
 */
export const MAX_BULK_SIGN_BATCH_SIZE = 20;

/**
 * Ceiling on a client-supplied selection array, well above MAX_BULK_SIGN_BATCH_SIZE. It bounds
 * validation cost, not the resolve: `@IsUUID(each)` runs before any business logic, so the
 * array needs a limit. The business caps are applied per actor downstream.
 */
export const MAX_BULK_SIGN_SELECTION_SIZE = 1000;

export enum ContainerType {
	PDF = 'pdf',
	ASICE = 'asice',
	CADES = 'cades',
	XADES = 'xades',
}

export enum BulkSignJobStatus {
	INITIATED = 'INITIATED',
	PREPARING = 'PREPARING',
	READY_TO_SIGN = 'READY_TO_SIGN',
	COMPLETING = 'COMPLETING',
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED',
}
